angular
  .module('contrast.services.rules.exclusion', [])
  .factory('RuleExclusionService', function ($translate, LanguagesService) {
    var ALL_OPTION = 'All Rules'
    var ALL_ASSESSMENT_OPTION = 'All Assessment'
    var ALL_PROTECTION_OPTION = 'All Protection'

    function removeAllOption(array, value) {
      var index = _.indexOf(array, value)
      if (index != -1) {
        array = array
          .slice(0, index)
          .concat(array.slice(index + 1, array.length))
      }
      return array
    }

    function removeOptionsType(array, type) {
      return _.reject(array, function (exception) {
        return exception.startsWith(type)
      })
    }

    function getCommonRules(protectionRules, assessmentRules) {
      if (protectionRules && assessmentRules) {
        return protectionRules.filter(
          (
            (set) => (a) =>
              set.has(a.uuid)
          )(new Set(assessmentRules.map((b) => b.name)))
        )
      }

      return new Array(0)
    }

    return {
      getExclusionTypes: function (language, event) {
        var exclusionTypes = {
          input: {
            value: 'INPUT',
            name: $translate.instant(
              'title_applicationExclusion_exclusionTypeInput'
            )
          },
          code: {
            value: 'CODE',
            name: $translate.instant(
              'title_applicationExclusion_exclusionTypeCode'
            )
          },
          url: {
            value: 'URL',
            name: $translate.instant(
              'title_applicationExclusion_exclusionTypeUrl'
            )
          }
        }
        var availableExclusionTypes = LanguagesService.isNode(language)
          ? []
          : [exclusionTypes.code]

        if (!event || event.source !== null) {
          availableExclusionTypes.push(exclusionTypes.input)
          availableExclusionTypes.push(exclusionTypes.url)
        }

        return availableExclusionTypes
      },
      onRulesUpdate: function ($scope, item, model) {
        if (model == ALL_OPTION) {
          $scope.model.rules = [ALL_OPTION]
          $scope.model.all_rules = true
          $scope.model.all_protection_rules = false
          $scope.model.all_assessment_rules = false
        } else {
          $scope.model.rules = removeAllOption($scope.model.rules, ALL_OPTION)
          $scope.model.all_rules = false
        }

        if (model == ALL_PROTECTION_OPTION) {
          $scope.model.all_protection_rules = true
          $scope.model.rules = removeOptionsType(
            $scope.model.rules,
            'protection:'
          )
          if ($scope.model.all_assessment_rules) {
            $scope.model.rules = removeOptionsType($scope.model.rules, 'both:')
          }
        } else {
          if (item.group == 'protection') {
            $scope.model.rules = removeAllOption(
              $scope.model.rules,
              ALL_PROTECTION_OPTION
            )
            $scope.model.all_protection_rules = false
          }
        }

        if (model == ALL_ASSESSMENT_OPTION) {
          $scope.model.all_assessment_rules = true
          $scope.model.rules = removeOptionsType(
            $scope.model.rules,
            'assessment:'
          )
          if ($scope.model.all_protection_rules) {
            $scope.model.rules = removeOptionsType($scope.model.rules, 'both:')
          }
        } else {
          if (item.group == 'assessment') {
            $scope.model.rules = removeAllOption(
              $scope.model.rules,
              ALL_ASSESSMENT_OPTION
            )
            $scope.model.all_assessment_rules = false
          }
        }

        if (item.group == 'assessment and protection') {
          if (
            $scope.model.all_protection_rules &&
            $scope.model.all_assessment_rules
          ) {
            $scope.model.rules = removeAllOption(
              $scope.model.rules,
              ALL_ASSESSMENT_OPTION
            )
            $scope.model.rules = removeAllOption(
              $scope.model.rules,
              ALL_PROTECTION_OPTION
            )
            $scope.model.all_protection_rules = false
            $scope.model.all_assessment_rules = false
          }
        }
      },
      onRulesDelete: function ($scope, item, model) {
        if (model === ALL_OPTION) {
          $scope.model.all_protection_rules = false
          $scope.model.all_assessment_rules = false
        }

        if (model === ALL_PROTECTION_OPTION) {
          $scope.model.all_protection_rules = false
        }

        if (model === ALL_ASSESSMENT_OPTION) {
          $scope.model.all_assessment_rules = false
        }

        if ($scope.model.rules.length == 0) {
          $scope.model.rules = [ALL_OPTION]
          $scope.model.all_rules = true
        }
      },

      addSwitchProperties: function (exclusion) {
        if (exclusion.all_rules) {
          exclusion.enabled_assess = true
          exclusion.enabled_protection = true
        } else {
          if (
            exclusion.all_assessment_rules ||
            (exclusion.assess_rules && exclusion.assess_rules.length > 0)
          ) {
            exclusion.enabled_assess = true
          } else {
            exclusion.enabled_assess = false
          }

          if (
            exclusion.all_protection_rules ||
            (exclusion.protection_rules &&
              exclusion.protection_rules.length > 0)
          ) {
            exclusion.enabled_protection = true
          } else {
            exclusion.enabled_protection = false
          }

          var commonRules = getCommonRules(
            exclusion.protection_rules,
            exclusion.assess_rules
          )

          if (commonRules && commonRules.length > 0) {
            exclusion.protection_rules = exclusion.protection_rules.filter(
              (
                (set) => (a) =>
                  !set.has(a.uuid)
              )(new Set(commonRules.map((b) => b.uuid)))
            )
            exclusion.assess_rules = exclusion.assess_rules.filter(
              (
                (set) => (a) =>
                  !set.has(a.name)
              )(new Set(commonRules.map((b) => b.uuid)))
            )

            exclusion.common_rules = commonRules
          }
        }
      }
    }
  })
